// @flow
import { statuses } from '../dataTypes/orders/statuses';


export const status2TranslationMap: Map<string, string> = new Map([
  [statuses.All, 'orders_filter_item_all'],
  [statuses.Spent, 'orders_filter_item_spent'],
  [statuses.Pending, 'orders_filter_item_pending'],
  [statuses.Removed, 'orders_filter_item_deleted'],
]);

export const status2ColorMap: Map<string, string> = new Map([
  [statuses.Spent, '#4caf50'],
  [statuses.Pending, '#ef6c00'],
  [statuses.Removed, '#e91e63'],
]);
